import { Pipe, PipeTransform } from '@angular/core';
import { Contact } from '../../contacts/contracts/contact.interface';

@Pipe({
  name: 'contactDisplay'
})
export class ContactDisplayPipe implements PipeTransform {

  transform(contact: Contact | null | undefined, fromNumber: string): string {
    if (!contact) {
      return fromNumber;
    }

    const first = contact.firstName?.trim();
    const last = contact.lastName?.trim();
    const company = contact.companyName?.trim();

    if (first && last) {
      return `${first} ${last}`;
    }

    if (company) {
      return company;
    }

    return fromNumber;
  }
}
